<template>
  <div :style="{ '--scale': scale }">
    <nx-checkbox v-bind="$attrs" :checkboxColor="checkboxColor" @click="$emit('click', $event)">
      <slot></slot>
    </nx-checkbox>
  </div>
</template>

<script>
import { create } from '../../utils'

// 文档地址： https://vos-ui.vmic.xyz/components/checkbox.html

export default create({
  name: 'checkbox',

  props: {
    /*********************** 整体封装 vos 组件属性 使其适配商城规范 ***********************/

    // 复选框色值
    checkboxColor: {
      type: [String],
      default: '#e90f23'
    },
    /*********************** 整体封装 vos 组件属性 使其适配商城规范 ***********************/

    // 勾选框放大属性 等vos 支持尺寸设置 此属性就可以不用了
    scale: {
      type: [Number, String],
      default: 1
    }
  },

  methods: {
    change(val) {
      this.$emit('change', val)
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
